import styled from 'styled-components';
const Subtitle = styled.div`
display:flex;
width:90%;
margin-bottom:10px;
justify-content:space-between;
@media screen and (max-width:1000px){
    width:85vw;
}
`;

export default Subtitle;